import React from 'react';
import {useTheme} from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPlus,FiEye,FiMessageSquare,FiCalendar,FiImage,FiHome}=FiIcons;

const SegnalatoreDashboard=({currentUser,segnalazioni,setCurrentView,setSelectedSegnalazione})=> {
  const {isDark}=useTheme();
  
  const mySegnalazioni=segnalazioni.filter(s=> s.user_id===currentUser.id);

  const getStatusColor=(status)=> {
    const colors={
      'In attesa': isDark ? 'bg-yellow-800 text-yellow-200' : 'bg-yellow-100 text-yellow-800',
      'Visionato': isDark ? 'bg-blue-800 text-blue-200' : 'bg-blue-100 text-blue-800',
      'Incarico preso': isDark ? 'bg-green-800 text-green-200' : 'bg-green-100 text-green-800',
      'Incarico non preso': isDark ? 'bg-red-800 text-red-200' : 'bg-red-100 text-red-800',
      'Venduto': isDark ? 'bg-purple-800 text-purple-200' : 'bg-purple-100 text-purple-800',
      'Rifiutato': isDark ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-800'
    };
    return colors[status] || (isDark ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-800');
  };

  const getStatusIcon=(status)=> {
    const icons={
      'In attesa': '⏳',
      'Visionato': '👁️',
      'Incarico preso': '✅',
      'Incarico non preso': '❌',
      'Venduto': '💰',
      'Rifiutato': '🚫'
    };
    return icons[status] || '📋';
  };

  if (mySegnalazioni.length===0) {
    return ( 
      <div className={`min-h-screen ${isDark ? 'bg-gray-900' : 'bg-gray-50'} transition-colors`}> 
        <div className="container mx-auto px-4 py-16"> 
          <div className="text-center max-w-2xl mx-auto"> 
            <div className="text-8xl mb-8">🏠</div> 
            <h2 className={`text-4xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-800'}`}> 
              Inizia a segnalare immobili 
            </h2> 
            <p className={`text-xl mb-8 leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-600'}`}> 
              Guadagna commissioni segnalando immobili alla nostra agenzia. Ogni segnalazione che si trasforma in vendita ti farà guadagnare! 
            </p> 
            <div className={`grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}> 
              <div className={`p-6 rounded-xl ${isDark ? 'bg-gray-800' : 'bg-white'} shadow-lg`}> 
                <div className="text-3xl mb-4">📍</div> 
                <h3 className="font-bold mb-2">Trova Immobili</h3> 
                <p className="text-sm">Cerca immobili in vendita nella tua zona</p> 
              </div> 
              <div className={`p-6 rounded-xl ${isDark ? 'bg-gray-800' : 'bg-white'} shadow-lg`}> 
                <div className="text-3xl mb-4">📝</div> 
                <h3 className="font-bold mb-2">Crea Segnalazione</h3> 
                <p className="text-sm">Compila il form con tutti i dettagli</p> 
              </div> 
              <div className={`p-6 rounded-xl ${isDark ? 'bg-gray-800' : 'bg-white'} shadow-lg`}> 
                <div className="text-3xl mb-4">💰</div> 
                <h3 className="font-bold mb-2">Guadagna</h3> 
                <p className="text-sm">Ricevi la tua commissione alla vendita</p> 
              </div> 
            </div> 
            <button onClick={()=> setCurrentView('nuova-segnalazione')} className="inline-flex items-center space-x-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-xl font-bold text-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 transform hover:scale-105 shadow-xl" > 
              <SafeIcon icon={FiPlus} className="w-6 h-6" /> 
              <span>Segnala il primo immobile</span> 
            </button> 
          </div> 
          
          {/* Footer */}
          <footer className={`mt-20 py-8 ${isDark ? 'border-gray-700' : 'border-gray-200'} border-t`}> 
            <div className={`text-center space-y-3 ${isDark ? 'text-gray-400' : 'text-gray-600'} text-sm leading-relaxed`}>
              <p className="font-semibold">
                HomeScout © 2025 di Dynamic-Web Srls – P.Iva 03034040356 – Tutti i diritti sono riservati
              </p>
              <p>
                Rag. Sociale: DYNAMIC-WEB SRLS - SOCIETA' A RESPONSABILITA' LIMITATA SEMPLIFICATA
              </p>
              <p className="pt-2 border-t border-gray-300 dark:border-gray-600">
                Questa applicazione è stata realizzata da Dynamic-Web Srls e utilizza Supabase per l'archiviazione sicura dei dati.
              </p>
            </div>
          </footer>
        </div> 
      </div> 
    );
  } 

  return ( 
    <div className={`min-h-screen ${isDark ? 'bg-gray-900' : 'bg-gray-50'} transition-colors`}> 
      <div className="container mx-auto px-4 py-8"> 
        {/* Header */} 
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4"> 
          <div> 
            <h2 className={`text-3xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}> 
              Le mie segnalazioni 
            </h2> 
            <p className={`mt-2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}> 
              {mySegnalazioni.length} segnalazione{mySegnalazioni.length !==1 ? 'i' : ''} attiva{mySegnalazioni.length !==1 ? 'e' : ''} 
            </p> 
          </div> 
          <button onClick={()=> setCurrentView('nuova-segnalazione')} className="flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 transition-all duration-200 transform hover:scale-105 shadow-lg" > 
            <SafeIcon icon={FiPlus} className="w-5 h-5" /> 
            <span>Nuova Segnalazione</span> 
          </button> 
        </div> 

        {/* Segnalazioni Grid */} 
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-20"> 
          {mySegnalazioni.map(segnalazione=> ( 
            <div key={segnalazione.id} className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-2xl shadow-lg overflow-hidden transition-all hover:shadow-xl transform hover:-translate-y-1`}> 
              {/* Foto Header */} 
              {segnalazione.images && segnalazione.images.length > 0 ? ( 
                <div className="relative h-48 overflow-hidden"> 
                  <img src={segnalazione.images[0].url} alt="Immobile" className="w-full h-full object-cover" /> 
                  <div className="absolute top-3 right-3"> 
                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusColor(segnalazione.stato_segnalazione)}`}> 
                      {getStatusIcon(segnalazione.stato_segnalazione)} {segnalazione.stato_segnalazione} 
                    </span> 
                  </div> 
                  {segnalazione.images.length > 1 && ( 
                    <div className="absolute bottom-3 right-3 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs"> 
                      <SafeIcon icon={FiImage} className="inline w-3 h-3 mr-1" /> +{segnalazione.images.length - 1} 
                    </div> 
                  )} 
                </div> 
              ) : ( 
                <div className={`h-48 flex items-center justify-center ${isDark ? 'bg-gray-700' : 'bg-gray-100'} relative`}> 
                  <div className="text-center"> 
                    <SafeIcon icon={FiImage} className={`w-12 h-12 mx-auto mb-2 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} /> 
                    <p className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}> 
                      Nessuna foto 
                    </p> 
                  </div> 
                  <div className="absolute top-3 right-3"> 
                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusColor(segnalazione.stato_segnalazione)}`}> 
                      {getStatusIcon(segnalazione.stato_segnalazione)} {segnalazione.stato_segnalazione} 
                    </span> 
                  </div> 
                </div> 
              )} 

              <div className="p-6"> 
                <div className="mb-4"> 
                  <h3 className={`font-bold text-lg mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`}> 
                    {segnalazione.indirizzo} 
                  </h3> 
                  <div className={`space-y-1 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'}`}> 
                    <p>🏠 {segnalazione.tipo_immobile} • {segnalazione.mq} mq</p> 
                    <p>👤 {segnalazione.nome_proprietario}</p> 
                    <p>📞 {segnalazione.telefono_proprietario}</p> 
                  </div> 
                </div> 

                {/* Aggiornamento dall'agenzia */} 
                {segnalazione.note_admin && segnalazione.user_id===currentUser.id && ( 
                  <div className={`mb-4 p-4 rounded-lg border-l-4 ${isDark ? 'bg-blue-900 border-blue-500' : 'bg-blue-50 border-blue-400'}`}> 
                    <div className="flex items-start space-x-2"> 
                      <SafeIcon icon={FiMessageSquare} className={`w-4 h-4 mt-0.5 ${isDark ? 'text-blue-300' : 'text-blue-600'}`} /> 
                      <div> 
                        <p className={`text-xs font-bold mb-1 ${isDark ? 'text-blue-300' : 'text-blue-900'}`}> 
                          💬 Aggiornamento dall'agenzia: 
                        </p> 
                        <p className={`text-sm ${isDark ? 'text-blue-200' : 'text-blue-800'}`}> 
                          {segnalazione.note_admin} 
                        </p> 
                      </div> 
                    </div> 
                  </div> 
                )} 

                <div className="flex items-center justify-between"> 
                  <div className="flex items-center space-x-1 text-xs text-gray-500"> 
                    <SafeIcon icon={FiCalendar} className="w-3 h-3" /> 
                    <span>{new Date(segnalazione.created_at).toLocaleDateString('it-IT')}</span> 
                  </div> 
                  <button onClick={()=> setSelectedSegnalazione(segnalazione)} className={`flex items-center space-x-1 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isDark ? 'text-blue-400 hover:bg-gray-700' : 'text-blue-600 hover:bg-blue-50'}`} > 
                    <SafeIcon icon={FiEye} className="w-4 h-4" /> 
                    <span>Dettagli</span> 
                  </button> 
                </div> 
              </div> 
            </div> 
          ))} 
        </div> 

        {/* Footer */}
        <footer className={`py-8 ${isDark ? 'border-gray-700' : 'border-gray-200'} border-t`}> 
          <div className={`text-center space-y-3 ${isDark ? 'text-gray-400' : 'text-gray-600'} text-sm leading-relaxed`}>
            <p className="font-semibold">
              HomeScout © 2025 di Dynamic-Web Srls – P.Iva 03034040356 – Tutti i diritti sono riservati
            </p>
            <p>
              Rag. Sociale: DYNAMIC-WEB SRLS - SOCIETA' A RESPONSABILITA' LIMITATA SEMPLIFICATA
            </p>
            <p className="pt-2 border-t border-gray-300 dark:border-gray-600">
              Questa applicazione è stata realizzata da Dynamic-Web Srls e utilizza Supabase per l'archiviazione sicura dei dati.
            </p>
          </div>
        </footer>
      </div> 
    </div> 
  );
};

export default SegnalatoreDashboard;